import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { scansAPI, resultsAPI, vulnScanAPI } from '../services/api';
import ScanResultsComponent from '../components/Scans/ScanResults';
import ShodanScanDetail from '../components/Scans/ShodanScanDetail';

const ScanResultsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backPath = location.state?.from || '/reconnaissance';
  const [scan, setScan] = useState(null);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vulnRedirect, setVulnRedirect] = useState(null);

  useEffect(() => {
    fetchScanAndResults();
    const interval = setInterval(fetchScanAndResults, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (!scan) return;
    const isNuclei = scan.module_name === 'nuclei_scan' || scan.scan_type === 'vulnerability';
    if (!isNuclei) return;
    vulnScanAPI.findByScanId(scan.id)
      .then((res) => {
        if (res.data?.vuln_scan_id) {
          setVulnRedirect(`/vulnerabilities/scans/${res.data.vuln_scan_id}/results`);
        }
      })
      .catch(() => {
        // No VulnScan record linked — fall through to generic view
      });
  }, [scan]);

  const fetchScanAndResults = async () => {
    try {
      const [scanRes, resultsRes] = await Promise.all([
        scansAPI.get(id),
        resultsAPI.list(id)
      ]);
      
      setScan(scanRes.data);
      setResults(resultsRes.data);
    } catch (error) {
      console.error('Failed to fetch scan results:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-shinobi-purple">Loading...</div>
      </div>
    );
  }

  if (!scan) {
    return (
      <div className="p-8">
        <div className="text-center">
          <h2 className="text-xl text-slate-500">Scan not found</h2>
          <button
            onClick={() => navigate(backPath)}
            className="mt-4 btn-cyber px-4 py-2 rounded"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (vulnRedirect) {
    return <Navigate to={vulnRedirect} replace state={location.state} />;
  }

  if (scan.module_name === 'shodan_scan') {
    return <ShodanScanDetail scan={scan} onBack={() => navigate(backPath)} />;
  }

  return (
    <ScanResultsComponent 
      scan={scan} 
      results={results}
      onBack={() => navigate(backPath)}
    />
  );
};

export default ScanResultsPage;
